import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../../lib/api-client';
import { DealerEstimateDetails } from '../types/DealerEstimateDetails';

export const useGetEstimate = (quoteID: number) => {
    const { data, isLoading, refetch, isRefetching } = useQuery({
        queryKey: ['dealer-estimate', quoteID],
        queryFn: async () => await apiClient.get('estimate/dealer-details',
            {
                params: {
                    quoteID: quoteID
                }
            }) as DealerEstimateDetails
    });

    return {
        data,
        isLoading,
        refetch,
        isRefetching
    };
};
